"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regular = exports.thin = void 0;
var _core = require("@emotion/core");
const thin = _ref => {
  let {
    theme,
    color
  } = _ref;
  return (0, _core.css)`
  border-style: solid;
  border-width: 1px;
  border-color: ${color || theme.bColorsecondary05};
`;
};
exports.thin = thin;
const regular = _ref2 => {
  let {
    theme
  } = _ref2;
  return (0, _core.css)`
  border-style: solid;
  border-width: 2px;
  border-color: ${theme.bColorsecondary05};
`;
};
exports.regular = regular;